import React from 'react';

interface Props {
    value: string | number | null;
    description?: string | null;
}

export default function DropdownLabel({ value, description }: Props) {
    return (
        <>
            <div
                title={value?.toString()}
                className="f-text-medium-content f-text-semibold f-color-dark-black-s80 truncate"
            >
                {value}
            </div>
            <div title={description?.toString()} className="f-text-content f-color-dark-black-s50 truncate">
                {description}
            </div>
        </>
    );
}
